"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _content = _interopRequireDefault(require("./content"));

var _colors = require("../constants/colors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var viewBox = '0 0 32 32';

var Icon = function Icon(_ref) {
  var type = _ref.type,
      fill = _ref.fill,
      width = _ref.width,
      otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["type", "fill", "width"]);

  var wrapperProps = _objectSpread({}, otherProps, {
    viewBox: viewBox,
    width: width
  }); // defaulting to a box, if the given type does not match another existing definition


  var iconPreset = _content["default"][type] || _content["default"].box;
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, wrapperProps, {
    xmlns: "http://www.w3.org/2000/svg"
  }), iconPreset(fill));
};

Icon.propTypes = {
  type: _propTypes["default"].string.isRequired,
  fill: _propTypes["default"].string,
  width: _propTypes["default"].string
};
Icon.defaultProps = {
  fill: _colors.DEEP_GRAY,
  width: '32px'
};
var _default = Icon;
exports["default"] = _default;
Icon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "fill": {
      "defaultValue": {
        "value": "DEEP_GRAY",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "defaultValue": {
        "value": "'32px'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};